import WizardStepPage from './WizardStepPage';

/** Step 3 — Pricing & payment templates */
const PricingStep = (props) => (
    <WizardStepPage
        stepKey="pricing"
        isStepDataLoading={props.isStepDataLoading}
        basePrice={props.formData?.pricing?.base_price ?? props.formData?.packages?.base_price}
        formData={props.formData?.pricing}
        onChange={props.onChange}
        errors={props.errors}
        setErrors={props.setErrors}
        paymentTemplates={props.paymentTemplates}
        onToggleTemplate={props.onToggleTemplate}
        onNewTemplate={props.onNewTemplate}
        onEditTemplate={props.onEditTemplate}
        tripCurrency={props.tripCurrency}
    />
);

export default PricingStep;
